module.exports = __webpack_public_path__ + "img/impactoF3.7a4c0747.png";